




















import Vue from "vue";
import Modal from "@/components/Modal/Modal.vue";
import { store } from "@/store/store";

export default Vue.extend({
  name: "DeviceStateModal",
  components: { Modal },
  props: {
    should_display: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => undefined
    },
    onValidate: {
      type: Function,
      default: () => undefined
    },
    status_list: {
      type: Array as () => Array<string>
    }
  },
  data() {
    return {
      status: this.$props.status_list,
      items: store.getters.STATE_ALL_ID.map((state_id) => store.getters.STATE_BY_ID[state_id].name)
    };
  },
  methods: {
    validate(): void {
      this.onValidate(this.status);
    }
  }
});
